module.exports = __webpack_public_path__ + "753166146f71daa528e8a0f17c2e04bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider/chat-white.svg
// module id = 1264
// module chunks = 61